import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#D8FFFF"
      d="M92.76 33.174a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M83.513 5.295a1.5 1.5 0 0 1 0 2.121l-9.994 9.994a1.5 1.5 0 0 1-2.122-2.121l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M71.397 5.295a1.5 1.5 0 0 1 2.122 0l9.994 9.994a1.5 1.5 0 1 1-2.122 2.121l-9.994-9.994a1.5 1.5 0 0 1 0-2.121"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M23.35 110.221a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M8.566 62.973a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 1 1-3 0V64.473a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M0 71.54a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 1 1 0 3H1.5a1.5 1.5 0 0 1-1.5-1.5M108.566 62.54a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12-.001 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M63.764 17.59a6.422 6.422 0 0 0-11.527 0L18.555 86.208A5.407 5.407 0 0 0 23.412 94h69.176a5.41 5.41 0 0 0 4.857-7.793z"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M53.974 79.793a3.587 3.587 0 1 1 7.174 0 3.587 3.587 0 0 1-7.174 0M57.561 38.764a2.25 2.25 0 0 1 2.25 2.25v26.744a2.25 2.25 0 1 1-4.5 0V41.014a2.25 2.25 0 0 1 2.25-2.25"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconCautionBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconCautionBrand);
export default Memo;
